

	import {Options, Vue} from "vue-property-decorator";

	@Options({})
	export default class TextArea extends Vue
	{
		public inheritAttrs: false;
	}
